
export default function Loader() {
    return (
    <div className="flex items-center justify-center h-screen fixed left-0 right-0 bg-[rgba(232,243,252,0.5)] z-[11] top-0">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-[#1F66A0] border-t-transparent"></div>
    </div>
    )
}